import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ModalDismissReasons, NgbCalendar, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppointmentDetail } from '../../../../../Administration/src/app/business-entities/appointmentDetail-model';
import { CustomPaggerService } from '../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import { ExcelService } from '../../../../../Autofacets-Core/src/app/common-services/export-excel.service';
import { GlobalSetting } from '../../../../../Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from '../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdSortableHeader, SortEvent } from '../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from '../../../../../Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from '../../../../../Autofacets-Core/src/app/utils/constant';
import { Utility } from '../../../../../Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UserDataService } from '../../../../../../src/app/DataServices/user-data.service';
import { CurrentLanguage } from '../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { AppointmentList, AppointmentRequestModel, AppointmentStatusRequestModel, UpdateAppointmentStatusDisplyModel } from '../../business-entities/appointmentList-model';
import { AppointmentStatus, AppointmentStatusList, DocumentPartStatus, WorkOrderStatus } from '../../business-entities/appointmentStatus-model';
import { BrandViewModel } from '../../business-entities/brand-view-model';
import { DealerViewModel } from '../../business-entities/dealer-view-model';
import { Filter } from '../../business-entities/Filter';
import { PagerData } from '../../business-entities/PagerData';
import { DeleteAdvanceSearchFilterModel, SaveAdvanceSearchFilterModel, SearchArrayModel } from '../../business-entities/save-advance-search-filter';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { Features } from '../../business-entities/user-role-view-model';
import { AdvanceSearchService } from '../../business-services/advance-search.service';
import { AppointmentService } from '../../business-services/appointment.service';
import { ArchivedAppointmentService } from '../../business-services/archived-appointment.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { SavedSearchComponent } from '../../components/saved-search/saved-search.component';
import { PaginationService } from '../../services/pagination.service';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { MultiStackPopupService } from '../../services/multi-stack-popup.service';
import { ApplicationSourceService } from '../../business-services/application-source.service';
import { ApplicationSource } from '../../business-entities/application-source';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { AppointmentCommonService } from '../../business-services/appointment-common.service';
import { MechanicService } from '../../business-services/mechanic.service';

@Component({
  selector: 'app-archived-appointment',
  templateUrl: './archived-appointment.component.html',
  styleUrls: ['./archived-appointment.component.css']
})
export class ArchivedAppointmentComponent implements OnInit, OnDestroy {
  appointmentList: AppointmentList[] = [];
  appointmentListPDF: AppointmentList[];
  features: Features[] = [];
  appointmentListExcelExportData: any[];
  workOrderStatusList: WorkOrderStatus[];
  workOrderStatus: WorkOrderStatus[] = [];
  statusId: number = Enums.AppointmentStatus.Cancelled;
  status: AppointmentStatus[] = [];
  appointmentStatusList: AppointmentStatusList[] = [];
  documentPartStatusList: DocumentPartStatus[] = [];
  brandList: BrandViewModel[];
  appointmentDetails:AppointmentList;
  bookingDate: any[] = [];
  createdDate: any[] = [];
  appointmentSub: Subscription;
  appointmentDay: string;
  closeResult: string;
  statusList: [] = [];
  DealerName: string = null;
  SelectedStatus: any = null;
  previousStatus:any;
  InvoicePrice : any = 0;
  searchTerm: string;
  dealerList: Array<SelectListItemViewModel>;
  dealerId: string = null;
  dealerSelected: string = '';
  serviceAdvisorSelected: string = '';
  mechanicSelected: string = '';
  id: string = '0';
  contactDetails: AppointmentDetail;
  isRentalCar: boolean = false;
  needAttention: number = 0;
  currentOffer: boolean = false;
  isWarrantyAppointment: boolean = false;
  isWarrantyDocumentSigned: any = null;
  isCustomerWaiting: boolean = false;
  isDisplayInvoice:boolean = false;
  isTireHotel: boolean = null;
  isTireHotelActive: boolean = false;
  serchfind: boolean = false;
  updateAppointmentStatusModel: UpdateAppointmentStatusDisplyModel = {
    WOnumber: '',
    WOstatus: null,
    WOstatusColor: '',
    WOstatusId: 0,
    appointmentStatus: '',
    appointmnetStatusColor: '',
    bookDate: '',
    customerName: '',
    dealerName: '',
    licensePlate: '',
    appointmentId: 0,
    appointmentStatusId: 0,
    jobDetails: 0,
    brandImg: '',
    model: '',
    appointmentGuid: '',
    bookDateTime: null
  }
  today = this.calendar.getToday();
  isAdvanceSearch: boolean = false;
  popupCloseResult = false;
  paginationSub: Subscription;
  paginationSubPDF: Subscription;
  userRoleRightsDetails: UserRoleMenu;
  licensePlateClass: string;
  currentlagSub: Subscription;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  pager: any = {};
  totalCount: number = 0;
  pagerData: PagerData = {
    page: 1,
    pagerSize: 25
  }
  dataRows: any[] = [];
  filter: Filter = new Filter();
  filterItems: any[];
  pagedItems: any[];
  appointmentListCountSub: Subscription;
  saveSearchFilter: SaveAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.ArchivedAppointment,
    saveSearchArray: []
  };
  deleteSearchFilter: DeleteAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.ArchivedAppointment,
  };
  isAdvanceDealerSearch: boolean = false;
  savedSearchListResponse: SaveAdvanceSearchFilterModel[] = [];
  appointmentStatusRequestModel: AppointmentStatusRequestModel = {
    bookingDate: null,
    createdDate: null,
    dealerId: null,
    serviceAdvisorId:null,
    mechanicId:null,
    appointmentStatusId: null,
    workOrderStatusId: null,
    customerName: null,
    languageCode: null,
    licensePlate: null,
    mobileNumber: null,
    woNumber: null,
    appointmentType:""
  };
  control = new FormControl();
  isFromDashboard: boolean = false;
  throttle = 100;
  scrollDistance = 1;
  isCurrentAppointmentOnHold:boolean=false;
  subscription : Subscription;
  onCloseTriggerSub : Subscription;
  debounceTimer;
  appointmentDayList: any[] = [];
  applicationSourceList: Array<SelectListItemViewModel>;
  selectedItems = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    searchPlaceholderText: 'Search here',
    maxHeight: 500
  };
  isOfferFeatureActive:boolean = false;
  isNeedAttentionActive: boolean = false;
  isShowDMSStatus:boolean = false;
  serviceAdvisorList: any;
  mechanics: any;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private readonly appointmentService: AppointmentService,
    private readonly archivedAppointmentService: ArchivedAppointmentService,
    private readonly advanceSearchService: AdvanceSearchService,
    private readonly spinner: NgxSpinnerService,
    public pService: CustomPaggerService,
    private readonly modalService: NgbModal,
    private readonly toastr: ToastrService,
    private readonly calendar: NgbCalendar,
    private readonly cookieservice: CookieService,
    private readonly translate: TranslateService,
    private readonly userService: UserDataService,
    private readonly excelService: ExcelService,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly globalSetting: GlobalSetting,
    private readonly dealerService: DealerBusinessService,
    private readonly pagerService: PaginationService,
    private readonly secureStorage: SecureStorage,
    private readonly multiStackPopupService: MultiStackPopupService,
    config: NgbModalConfig,
    private readonly _eref: ElementRef,
    private readonly cdr: ChangeDetectorRef,
    public datepipe: DatePipe,
    private readonly applicationSourceService: ApplicationSourceService,
    private readonly appointmentCommonService: AppointmentCommonService,
    private readonly mechanicService: MechanicService
  ) {
    this.pService.pageSize = 25;
    this.pService.searchby = ['licensePlate', 'dealerName', 'customerName', 'workOrderNo', 'mobileNo'];
    this.pService.searchTerm = '';

    config.backdrop = 'static';
    config.keyboard = false;
    this.isCurrentAppointmentOnHold=false;
  }
  async onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.archivedAppointmentService.appointmentRequestModel.sortColumn = column;
    this.archivedAppointmentService.appointmentRequestModel.sortDirection = direction;
    this.archivedAppointmentService.appointmentRequestModel.startRecordNumber = 0;

    this.appointmentList = [];
    await this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);
  }
  async ngOnInit(): Promise<void> {
    this.getFeatures();
    this.archivedAppointmentService.appointmentRequestModel.startRecordNumber = 0;
    this.appointmentList = []
    this.appointmentDay = this.archivedAppointmentService.AppointmentDay;
    this.GetDealerList();
    this.appointmentListCountSub = this.currentLanguageService.appointmentListCount.subscribe(x => {
      this.totalCount = x;
    })
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.ArchivedAppointment);
    this.onCloseTriggerSub = this.multiStackPopupService.onCloseTrigger.subscribe((res) => {
      if (res) {
        this.archivedAppointmentService.appointmentRequestModel.startRecordNumber = 0;
        this.appointmentList = [];
        this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);
      }
    });
    this.pService.dataSource = [];
    this.archivedAppointmentService.appointmentRequestModel.dealerId = this.userService.currentUserValue.dealerId
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    if(this.dealerId != null && this.dealerId != undefined && this.dealerId != ''){
      await this.appointmentCommonService.getServiceAdvisorDetails(this.dealerId);
      this.serviceAdvisorList = this.appointmentCommonService.serviceAdvisorList;
      await this.getAllMechanics();
    }
  }
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event && event.target.className.indexOf('ng-option')==-1 && event.target.className.indexOf('btn')==-1) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }
  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if(this.features == null || this.features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        this.features = res;
        this.isOfferFeatureActive = this.features.find(x => x.featureCode === Enums.FeatureCode.OFFER)?.isActive;
        this.isNeedAttentionActive = this.features.find(x => x.featureCode === Enums.FeatureCode.NeedAttention)?.isActive;
        this.isShowDMSStatus = this.features.find(x => x.featureCode === Enums.FeatureCode.ShowDMSStatus)?.isActive;
        this.isTireHotelActive = this.features.find(x => x.featureCode === Enums.FeatureCode.TireHotel)?.isActive;
      })
    }
  }

  changeRentalCarType(event: Event) {
    this.isRentalCar = (event.target as HTMLInputElement).checked;
    this.archivedAppointmentService.appointmentRequestModel.isRentalCar = this.isRentalCar ? 1 : 2;
  }

  changeTireHotel(event: Event) {
    this.isTireHotel = (event.target as HTMLInputElement).checked ? true : false;
    this.archivedAppointmentService.appointmentRequestModel.isTireHotel = this.isTireHotel;
  }

  async ChangeAppointmentDay(){
    let dateObject;let date_format;
    if(this.appointmentDay){
      this.archivedAppointmentService.AppointmentDay = this.appointmentDay;
      switch(this.appointmentDay){
        case Enums.AppointmentDay.TodayAppointment:{
          this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = null;
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate()));
          break;
        }
        case Enums.AppointmentDay.TomorrowAppointment:{
          this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = null;
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate() + 1));
          break;
        }
        case Enums.AppointmentDay.YesterdayAppointment:{
          this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = null;
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() - 1)), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() - 1)), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate() - 1));
          break;
        }
        case Enums.AppointmentDay.TodayCheckedInAppointment:{
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate()));
          this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.CheckedIn;
          break;
        }
        case Enums.AppointmentDay.TomorrowCheckedInAppointment:{
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate() + 1));
          this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.CheckedIn;
          break;
        }
        case Enums.AppointmentDay.TodayNotCheckedInAppointment:{
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate()));
          this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.Confirmed;
          break;
        }
        case Enums.AppointmentDay.TomorrowNotCheckedInAppointment:{
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate() + 1));
          this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.Confirmed;
          break;
        }
        case Enums.AppointmentDay.TodayCancelledAppointment:{
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate())), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate()));
          this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.Cancelled;
          break;
        }
        case Enums.AppointmentDay.TomorrowCancelledAppointment:{
          dateObject = {
            beginDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy'),
            endDate: this.datepipe.transform(new Date(new Date().setDate(new Date().getDate() + 1)), 'dd/MM/yyyy')
          };
          date_format = new Date(new Date().setDate(new Date().getDate() + 1));
          this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = Enums.AppointmentStatus.Cancelled;
          break;
        }
      }
      let bookingDate = dateObject.beginDate + ' - ' + dateObject.endDate;
      this.archivedAppointmentService.appointmentRequestModel.bookingDate = bookingDate;
      this.bookingDate=[];
      this.bookingDate.push(date_format);
      this.bookingDate.push(date_format);
    }
    else{
      this.archivedAppointmentService.appointmentRequestModel.bookingDate = null;
      this.bookingDate = [];
      this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = null;
      this.archivedAppointmentService.AppointmentDay = null;
    }
     this.appointmentList = [];
    if(!this.isFromDashboard){
      await this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);
    }
  }

  changeNeedAttention(event: Event) {
    this.needAttention = (event.target as HTMLInputElement).checked ? 1 : 0;
    this.archivedAppointmentService.appointmentRequestModel.needAttention = this.needAttention;
  }

  changeCurrentOffer(event: Event) {
    this.currentOffer = (event.target as HTMLInputElement).checked;
    this.archivedAppointmentService.appointmentRequestModel.currentOffer = this.currentOffer ? 1 : 2;
  }

  changeIsWarrantyAppointment(event: Event) {
    this.isWarrantyAppointment = (event.target as HTMLInputElement).checked;
    this.archivedAppointmentService.appointmentRequestModel.isWarrantyAppointment = this.isWarrantyAppointment ? 1 : 0;
    this.isWarrantyDocumentSigned = null;
    this.archivedAppointmentService.appointmentRequestModel.isWarrantyDocumentSigned = this.isWarrantyDocumentSigned;
  }

  changeIsCustomerWaiting(event: Event) {
    this.isCustomerWaiting = (event.target as HTMLInputElement).checked;
    this.archivedAppointmentService.appointmentRequestModel.customerWaiting = this.isCustomerWaiting? 1 : 0;
  }

  async setPage(pagerData: PagerData) {
    if (pagerData == null || pagerData === undefined || pagerData.page < 1 || pagerData.page > this.pager.totalPages) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
    this.archivedAppointmentService.appointmentRequestModel.startRecordNumber = (pagerData.pagerSize * (pagerData.page - 1));
    this.archivedAppointmentService.appointmentRequestModel.pageSize = pagerData.pagerSize;
    await this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);

  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;

    pageData.recordSize = this.totalCount;

  }
  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }
  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = (data.length === 0) ? 0 : 1;
    return this.initilisePagerFromServer(this.filter.page, Number(this.filter.pageSize), count);
  }


  initilisePagerFromServer(page: number, _pageSize: number, count: number = this.filterItems.length) {

    this.filter.pageSize = this.pagerData.pagerSize;
    this.pager = this.pagerService.getPager(count, page, this.pagerData.pagerSize);
    this.pagedItems = this.filterItems; // .slice(this.pager.startIndex, this.pager.endIndex + 1);
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  async GetDealerList() {
    await this.dealerService.getDealerBrandList().then(res => {
      if (res) {
        if (res.dealerList) {
          this.dealerList = this.mapdealer(res.dealerList);
        }
        this.brandList = res.brandList;
        if (this.brandList && this.brandList.length > 0) {
          this.GetAllAppointmentStatusList();
        }
      }
    })
  }

  mapdealer(array: DealerViewModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  async onDealerSelected(dealerId: string, flag: string) {
    this.dealerId =  dealerId ?? null  ;
    this.dealerSelected = this.dealerList.find(x => x.value === dealerId)?.text;

    this.archivedAppointmentService.appointmentRequestModel.dealerId = this.dealerId;
    if(dealerId?.length > 0){
      this.serviceAdvisorSelected = null;
      this.mechanicSelected = null;
      this.archivedAppointmentService.appointmentRequestModel.serviceAdvisorId = null;
      this.archivedAppointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor = false;
      this.archivedAppointmentService.appointmentRequestModel.mechanicId = null;
      await this.appointmentCommonService.getServiceAdvisorDetails(this.dealerId);
      this.serviceAdvisorList = this.appointmentCommonService.serviceAdvisorList;
      await this.getAllMechanics();
      this.cdr.detectChanges();
    }
    else {
      this.serviceAdvisorSelected = null;
      this.mechanicSelected = null;
      this.serviceAdvisorList = [];
      this.mechanics = [];
    }
    if (flag === 'dealerDropdown') {
      this.isAdvanceDealerSearch = false;
      this.archivedAppointmentService.appointmentRequestModel.startRecordNumber = 0;
      this.appointmentList = [];
      this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);
    }
    else {
      this.serviceAdvisorSelected = null;
      this.mechanicSelected = null;
      this.archivedAppointmentService.appointmentRequestModel.serviceAdvisorId = null;
      this.archivedAppointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor = false;
      this.archivedAppointmentService.appointmentRequestModel.mechanicId = null;
      this.isAdvanceDealerSearch = true;
    }
  }


  onDownloadPDF(pdf: number) {
    this.GetAppointmentListDocument(pdf);
  }

  exportAsXLSX(excel: number) {
    this.GetAppointmentListDocument(excel);
  }

  onRefresh() {
    this.appointmentDay = null;
    this.archivedAppointmentService.AppointmentDay = null;
    this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = null;
    this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId = null;
    this.bookingDate = [];
    this.createdDate = [];
    this.archivedAppointmentService.appointmentRequestModel.languageCode = this.cookieservice.get('userSelectedLanguage');
    this.archivedAppointmentService.appointmentRequestModel.createdDate = null;
    this.archivedAppointmentService.appointmentRequestModel.bookingDate = null;
    this.archivedAppointmentService.appointmentRequestModel.dealerId = "";
    this.archivedAppointmentService.appointmentRequestModel.serviceAdvisorId = null;
    this.archivedAppointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor = false;
    this.archivedAppointmentService.appointmentRequestModel.mechanicId = null;
    this.archivedAppointmentService.appointmentRequestModel.searchTerm = this.searchTerm;
    this.archivedAppointmentService.appointmentRequestModel.customerName = null;
    this.archivedAppointmentService.appointmentRequestModel.mobileNumber = null;
    this.archivedAppointmentService.appointmentRequestModel.woNumber = null;
    this.archivedAppointmentService.appointmentRequestModel.licensePlate = null;
    this.archivedAppointmentService.appointmentRequestModel.startRecordNumber = 0;
    this.archivedAppointmentService.appointmentRequestModel.appointmentType = "";
    this.archivedAppointmentService.appointmentRequestModel.brandCode = null;
    this.archivedAppointmentService.appointmentRequestModel.documentPartStatus = null;
    this.archivedAppointmentService.appointmentRequestModel.pageSize = this.pagerData.pagerSize;
    this.dealerSelected = '';
    this.serviceAdvisorSelected = '';
    this.mechanicSelected = '';
    this.dealerId = null;
    this.archivedAppointmentService.appointmentRequestModel.isRentalCar = 2;
    this.archivedAppointmentService.appointmentRequestModel.currentOffer = 2;
    this.archivedAppointmentService.appointmentRequestModel.isTireHotel = null;
    this.archivedAppointmentService.appointmentRequestModel.customerWaiting = 0;
    this.selectedItems = [];
    this.appointmentList = [];
    this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);
  }
  onEdit(appointment: any) {
    this.multiStackPopupService.OpenAppointment(appointment.id);
  }
  onView(appointment: any) {
    this.multiStackPopupService.OpenAppointment(appointment.id);
  }
  onSearch() {
    if (this.applicationSourceList == undefined) {
      this.GetApplicationSource();
    }
    this.isAdvanceSearch = true;
  }
  async GetApplicationSource(): Promise<void> {
    await this.applicationSourceService.getApplicationSource().then(data => {
      this.applicationSourceList = this.mapSource(data.responseObject).filter(source => source.value === Enums.SourceId.Planner || source.value === Enums.SourceId.DMS || source.value === Enums.SourceId.Widget);
    });
  }
  mapSource(array: ApplicationSource[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.value = element.sourceId
        single.text = element.sourceName
        supperArray.push(single);
      })
    }
    return supperArray;
  }
  onSourceDeselect() {
    this.isAdvanceSearch = true;
  }
  handleSource(element, sourceList) {
    const sourceStr = element.searchValue.split(",");
    if (sourceList && sourceStr) {
      sourceStr.forEach(y => {
        const matchingSource = sourceList.find(x => x.text === y);
        if (matchingSource) {
          this.selectedItems.push(matchingSource);
        }
      });
    }
    this.archivedAppointmentService.appointmentRequestModel.sourceOfCreation = this.selectedItems.map(x => x.value).join(',');
  }

  onEnterPress(){
    this.debounceFunction(()=>this.onSearchFilter(),500);
  }

  debounceFunction(func,delay){
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }
  async onSearchFilter() {
    this.archivedAppointmentService.appointmentRequestModel.startRecordNumber = Constant.startRecordNumber;
    this.archivedAppointmentService.appointmentRequestModel.pageSize = this.pagerData.pagerSize <= Constant.GridPagerSize ? Constant.GridPagerSize : this.pagerData.pagerSize;
    this.archivedAppointmentService.appointmentRequestModel.searchTerm = this.searchTerm;
    this.archivedAppointmentService.appointmentRequestModel.languageCode = this.cookieservice.get('userSelectedLanguage');
    this.appointmentList = [];
    try {
      await this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);
    }
    catch{
      this.spinner.hide();
    }
  }

  GetAppointmentStatusList(statusId: number, statusType: number) {
    this.pService.searchTerm = '';
    if (statusType === 1) {
      this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId = null;
      if (this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId === statusId) {
        this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = null;
      }
      else {
        this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = statusId;
      }
    }
    if (statusType === 2) {
      this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = null;
      if (this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId === statusId) {
        this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId = null;
      }
      else {
        this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId = statusId;
      }
    }
    this.archivedAppointmentService.appointmentRequestModel.searchTerm = this.searchTerm;
    this.archivedAppointmentService.appointmentRequestModel.languageCode = this.cookieservice.get('userSelectedLanguage')
    this.archivedAppointmentService.appointmentRequestModel.startRecordNumber = Constant.startRecordNumber;
    this.archivedAppointmentService.appointmentRequestModel.pageSize = this.pagerData.pagerSize <= Constant.GridPagerSize ? Constant.GridPagerSize : this.pagerData.pagerSize;
    this.pagerData.page = 1;
    this.appointmentList = [];
    this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);

  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  GetAllAppointmentStatusList() {
    let language = this.cookieservice.get('userSelectedLanguage');
    this.spinner.show();
    this.appointmentService.GetAppointmentStatusList(language).then(data => {
      if (data?.woStatusList) {
        this.appointmentStatusList = data.aoStatusList;
        this.workOrderStatusList = data.woStatusList;
        this.archivedAppointmentService.appointmentStatusList = this.appointmentStatusList;
        this.documentPartStatusList = data.documentParts;

        if (this.appointmentStatusList && this.appointmentStatusList.length > 0) {
            this.currentLanguageService.currentLanguage.subscribe(x => {
            this.archivedAppointmentService.appointmentRequestModel.languageCode = x;
            this.archivedAppointmentService.appointmentRequestModel.startRecordNumber = 0;
            this.archivedAppointmentService.appointmentRequestModel.pageSize = this.pagerData.pagerSize;
            this.archivedAppointmentService.appointmentRequestModel.isRentalCar = 2;
            this.archivedAppointmentService.appointmentRequestModel.currentOffer = 2;
            this.archivedAppointmentService.appointmentRequestModel.customerWaiting = 0;

              this.appointmentList = [];
              if(this.appointmentDay){
                this.isFromDashboard = true;
                this.ChangeAppointmentDay();
              }
              else{
                this.isFromDashboard = false;
              }
              this.archivedAppointmentService.appointmentRequestModel.dealerId =  this.dealerId ?? '';
              this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel, true);
          }).unsubscribe();
        }
      }
      setTimeout(() => {
        this.spinner.hide();
      }, 5000);
    })
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    if (this.appointmentSub) {
      this.appointmentSub.unsubscribe();
    }
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    if(this.onCloseTriggerSub){
      this.onCloseTriggerSub.unsubscribe();
    }
    this.archivedAppointmentService.AppointmentDay = null
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
    this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = null;
    this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId = null;
    this.archivedAppointmentService.appointmentRequestModel.createdDate = null;
    this.archivedAppointmentService.appointmentRequestModel.bookingDate = null;
    this.archivedAppointmentService.appointmentRequestModel.dealerId = null;
    this.archivedAppointmentService.appointmentRequestModel.serviceAdvisorId = null;
    this.archivedAppointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor = false;
    this.archivedAppointmentService.appointmentRequestModel.mechanicId = null;
    this.archivedAppointmentService.appointmentRequestModel.searchTerm = null;
    this.archivedAppointmentService.appointmentRequestModel.appointmentType = "";
    this.archivedAppointmentService.appointmentRequestModel.brandCode = null;
    this.archivedAppointmentService.appointmentRequestModel.documentPartStatus = null;
  }
  getValuesForCarAndOffer(){
     if(!this.isRentalCar && this.archivedAppointmentService.appointmentRequestModel.isRentalCar === 2){
      return 2;
     }else if(this.isRentalCar){
        return 1;
      }else{
        return 0;
      }
  }
  AdvanceSearchSubmit() {
    this.archivedAppointmentService.appointmentRequestModel.sourceOfCreation = "";
    if (this.selectedItems.length > 0) {
      this.archivedAppointmentService.appointmentRequestModel.sourceOfCreation = this.selectedItems.map(x => x.value).join(',')
    }
    this.archivedAppointmentService.appointmentRequestModel.isRentalCar = this. getValuesForCarAndOffer() ;
    this.archivedAppointmentService.appointmentRequestModel.searchTerm = this.searchTerm;
    this.archivedAppointmentService.appointmentRequestModel.languageCode = this.cookieservice.get('userSelectedLanguage');
    this.archivedAppointmentService.appointmentRequestModel.dealerId = this.dealerId;
    this.archivedAppointmentService.appointmentRequestModel.serviceAdvisorId = (this.serviceAdvisorSelected?.length == 0 || this.serviceAdvisorSelected == null) ? this.archivedAppointmentService.appointmentRequestModel.serviceAdvisorId : this.serviceAdvisorSelected;
    this.archivedAppointmentService.appointmentRequestModel.mechanicId = (this.mechanicSelected?.length == 0 || this.mechanicSelected == null) ? this.archivedAppointmentService.appointmentRequestModel.mechanicId : this.mechanicSelected;
    this.archivedAppointmentService.appointmentRequestModel.startRecordNumber = Constant.startRecordNumber;
    this.archivedAppointmentService.appointmentRequestModel.pageSize = this.pagerData.pagerSize <= Constant.GridPagerSize ? Constant.GridPagerSize : this.pagerData.pagerSize;
    this.archivedAppointmentService.appointmentRequestModel.currentOffer =this. getValuesForCarAndOffer() ;
    this.appointmentList = [];
    this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);
    this.isAdvanceSearch = false;
  }
  onReset() {
    this.appointmentDay = null;
    this.isRentalCar = false;
    this.needAttention = 0;
    this.currentOffer = false;
    this.isTireHotel = null;
    this.isWarrantyAppointment = false;
    this.isWarrantyDocumentSigned = null;
    this.archivedAppointmentService.appointmentRequestModel.needAttention = 0;
    this.archivedAppointmentService.appointmentRequestModel.isWarrantyAppointment = 0;
    this.archivedAppointmentService.appointmentRequestModel.isWarrantyDocumentSigned = null;
    this.archivedAppointmentService.appointmentRequestModel.includeArchive = false;
    this.archivedAppointmentService.appointmentRequestModel.isRentalCar = 2;
    this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = null;
    this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId = null;
    this.bookingDate = [];
    this.createdDate = [];
    this.archivedAppointmentService.appointmentRequestModel.createdDate = null;
    this.archivedAppointmentService.appointmentRequestModel.bookingDate = null;
    this.archivedAppointmentService.appointmentRequestModel.dealerId = "";
    this.serviceAdvisorSelected = null;
    this.mechanicSelected = null;
    this.archivedAppointmentService.appointmentRequestModel.serviceAdvisorId = null;
    this.archivedAppointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor = false;
    this.archivedAppointmentService.appointmentRequestModel.mechanicId = null;
    this.dealerId = null;
    this.selectedItems = [];
    this.archivedAppointmentService.appointmentRequestModel.sourceOfCreation = "";
    this.archivedAppointmentService.appointmentRequestModel.customerName = null;
    this.archivedAppointmentService.appointmentRequestModel.mobileNumber = null;
    this.archivedAppointmentService.appointmentRequestModel.woNumber = null;
    this.archivedAppointmentService.appointmentRequestModel.appointmentType = "";
    this.archivedAppointmentService.appointmentRequestModel.brandCode = null;
    this.archivedAppointmentService.appointmentRequestModel.documentPartStatus = null;
    this.archivedAppointmentService.appointmentRequestModel.licensePlate = null;
    this.archivedAppointmentService.appointmentRequestModel.currentOffer = 2;
    this.archivedAppointmentService.appointmentRequestModel.customerWaiting = 0;
    this.archivedAppointmentService.appointmentRequestModel.isTireHotel = null;
    this.AdvanceSearchSubmit();
  }
  onClose() {
    this.onReset();
    this.isAdvanceSearch = false;
  }

  onClearFilter()
  {
    this.onReset();
    //for sync drop down & quick serach clear
    this.searchTerm='';
    this.archivedAppointmentService.appointmentRequestModel.searchTerm=this.searchTerm;
    this.appointmentList=[];
    this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);
  }

  onResetSaveSearch() {
    this.appointmentList = [];
    this.appointmentDay = null;
    this.isRentalCar = false;
    this.needAttention = 0;
    this.currentOffer = false;
    this.archivedAppointmentService.appointmentRequestModel.needAttention = 0;
    this.archivedAppointmentService.appointmentRequestModel.includeArchive = false;
    this.archivedAppointmentService.appointmentRequestModel.isRentalCar = 2;
    this.archivedAppointmentService.appointmentRequestModel.isTireHotel = null;
    this.archivedAppointmentService.appointmentRequestModel.currentOffer = 2;
    this.archivedAppointmentService.appointmentRequestModel.customerWaiting = 0;
    this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = null;
    this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId = null;
    this.bookingDate = [];
    this.createdDate = [];
    this.archivedAppointmentService.appointmentRequestModel.createdDate = null;
    this.archivedAppointmentService.appointmentRequestModel.bookingDate = null;
    this.archivedAppointmentService.appointmentRequestModel.dealerId = this.userService.currentUserValue.dealerId;
    this.dealerId = null;
    this.serviceAdvisorSelected = null;
    this.mechanicSelected = null;
    this.archivedAppointmentService.appointmentRequestModel.serviceAdvisorId = null;
    this.archivedAppointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor = false;
    this.archivedAppointmentService.appointmentRequestModel.mechanicId = null;
    this.archivedAppointmentService.appointmentRequestModel.customerName = null;
    this.archivedAppointmentService.appointmentRequestModel.mobileNumber = null;
    this.archivedAppointmentService.appointmentRequestModel.woNumber = null;
    this.archivedAppointmentService.appointmentRequestModel.appointmentType = "";
    this.archivedAppointmentService.appointmentRequestModel.brandCode = null;
    this.archivedAppointmentService.appointmentRequestModel.documentPartStatus = null;
    this.archivedAppointmentService.appointmentRequestModel.licensePlate = null;
    this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);
  }
  async GetAppointmentListDocument(type) {
    this.spinner.show();
    this.archivedAppointmentService.appointmentRequestModel.isForDocuments = true;
    await this.archivedAppointmentService.GetArchivedAppointmentList(this.archivedAppointmentService.appointmentRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        let list = response.responseObject.appointmentList;
        this.cdr.detectChanges();
        if (type === Enums.DocumentsType.Pdf) {
          this.cdr.detectChanges();
          this.AppointmentPDFDataMapper(list)
        }
        if (list && list.length > 0 && type === Enums.DocumentsType.Excel) {
          this.appointmentListExcelExportData = this.ExcelDataMapping(list);
          this.excelService.exportAsExcelFile(this.appointmentListExcelExportData, 'Appointment List');
        }
        this.archivedAppointmentService.appointmentRequestModel.isForDocuments = false;
        this.spinner.hide();
      }
    });
    this.spinner.hide()
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.appointmentList.length) {
      this.archivedAppointmentService.appointmentRequestModel.startRecordNumber = this.appointmentList.length
      this.GetAppointmentList(this.archivedAppointmentService.appointmentRequestModel);
    }
  }

  async GetAppointmentList(appointmentRequestModel: AppointmentRequestModel, fromIntialize: boolean = false) {
    this.spinner.show();
    this.isFromDashboard = false;
    if (fromIntialize) {
      appointmentRequestModel.bookingDate = this.archivedAppointmentService.appointmentRequestModel.bookingDate;
    }
    else {
      let bookingDateFormatted= this.getFormattedDate(this.bookingDate);  
      let createdDateFormatted= this.getFormattedDate(this.createdDate);
      appointmentRequestModel.bookingDate = bookingDateFormatted;
      appointmentRequestModel.createdDate = createdDateFormatted;
    }

    await this.archivedAppointmentService.GetArchivedAppointmentList(appointmentRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.appointmentList.push(...this.AppointmentDataMapper(response.responseObject.appointmentList));
        this.totalCount = this.appointmentList.length > 0 ? this.appointmentList[0].totalCount : 0

        if (this.appointmentList && this.appointmentList.length > 0) {
          const unique = [...new Set(this.appointmentList.map(item => item.dealerName))]; // [ 'A', 'B']
          this.DealerName = unique.join(", ");
        }
        this.resetPagerData(this.supplierInitiliseGridFromServer(this.appointmentList, this.totalCount));
        if (this.pagerData.page > 1) {
          this.resetPagerData(this.initilisePagerFromServer(this.pagerData.page, this.pagerData.pagerSize, this.totalCount));
        }
        this.spinner.hide();
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.ServiceCategoriesCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  async getAllMechanics(): Promise<void> {
    await this.mechanicService.GetMechanicList(this.dealerId, Enums.StatusCode.Active).then((response) => {
      this.mechanics = response.responseObject;
    });
  }

  getSelectedServiceAdvisorName(): string {
    const selectedServiceAdvisorId = this.serviceAdvisorSelected;

    if (!selectedServiceAdvisorId || !this.serviceAdvisorList?.length) {
      return '';
    }

    return this.serviceAdvisorList.find(x => x.userId === selectedServiceAdvisorId)?.userName || '';
  }

  private AppointmentPDFDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.rowNumber = (this.archivedAppointmentService.appointmentRequestModel.startRecordNumber + 1) + index;
        single.id = element.id;
        single.licensePlate = element.licensePlate;
        single.customerName = element.customerName;
        single.mobileNo = element.mobileNo;
        single.mobileCode = element.mobileCode;
        single.dealerName = element.dealerName;
        single.appointmentStatusColor = element.appointmentStatusColor;
        single.brand = element.brandCode;
        single.dealerId = element.dealerId;
        single.modelName = element.modelName;
        single.brandCode = element.brandCode;
        single.brandName = element.brandName;
        single.workOrderNo = element.workOrderNo;
        single.workOrderStatus = element.workOrderStatus;
        single.workOrderStatusId = element.workOrderStatusId;
        single.workOrderStatusColor = element.workOrderStatusColor;
        single.appointmentStatusId = element.appointmentStatusId;
        single.bookedDate = element.bookedDate;
        single.createdDate = element.createdDate;
        single.createdDateTime = element.createdDateTime;
        single.bookedDateTime = element.bookedDateTime;
        single.appointmentType = element.appointmentType;
        single.appointmentGuid = element.appointmentGuid;
        single.createdTime = element.createdTime;
        single.appointmentStatus = element.appointmentStatus;
        single.isBookingAllowed = element.isBookingAllowed;
        supperArray.push(single);
      }
    }
    this.appointmentListPDF = supperArray;
    this.cdr.detectChanges();
    if (this.appointmentListPDF && this.appointmentListPDF.length > 0) {
      this.spinner.show();
      const doc = new jsPDF();
      autoTable(doc, { html: '#PDFdata', margin: { top: 3, left: 3, right: 3, bottom: 3 }, styles: { fontSize: 8 }, columnStyles: { 0: { cellWidth: 9 }, 5: { cellWidth: 25 }, 6: { cellWidth: 15 }, 8: { cellWidth: 22 } } });
      doc.save('Appointment-List.pdf');
      this.spinner.hide();
    }
  }
  private AppointmentDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.rowNumber = (this.archivedAppointmentService.appointmentRequestModel.startRecordNumber + 1) + index;
        single.id = element.id;
        single.licensePlate = element.licensePlate;
        single.customerName = element.customerName;
        single.mobileNo = element.mobileNo;
        single.mobileCode = element.mobileCode;
        single.dealerName = element.dealerName;
        single.appointmentStatusColor = element.appointmentStatusColor;
        single.brand = element.brandCode;
        single.dealerId = element.dealerId;
        single.modelName = element.modelName;
        single.brandCode = element.brandCode;
        single.brandName = element.brandName;
        single.approvedDemand = element.approvedDemand;
        single.workOrderNo = element.workOrderNo;
        single.workOrderStatus = element.workOrderStatus;
        single.jobDetails = element.jobDetails;
        single.workOrderStatusId = element.workOrderStatusId;
        single.workOrderStatusColor = element.workOrderStatusColor;
        single.appointmentStatusId = element.appointmentStatusId;
        single.bookedDate = element.bookedDate;
        single.createdDate = element.createdDate;
        single.createdDateTime = element.createdDateTime ? new Date(element.createdDateTime + 'Z') : null;
        single.bookedDateTime = element.bookedDateTime;
        single.appointmentType = element.appointmentType;
        single.appointmentGuid = element.appointmentGuid;
        single.createdTime = element.createdTime;
        single.appointmentStatus = element.appointmentStatus;
        single.isBookingAllowed = element.isBookingAllowed;
        single.sourceCreation = element.sourceCreation;
        single.unitPrice = element.unitPrice;
        single.chassisNo = element.chassisNo;
        single.totalCount = element.totalCount;
        single.isRentalCarRequired = element.isRentalCarRequired;
        single.dmsSyncStatus = element.dmsSyncStatus
        single.dmsSyncDate = element.dmsSyncDate ? new Date(element.dmsSyncDate + 'Z') : null;
        single.needAttention = element.needAttention;
        single.includeArchive = element.includeArchive;
        single.documentPartStatus = element.documentPartStatus;
        single.currentOffer= element.currentOffer;
        single.isServiceContractVehicle = element.isServiceContractVehicle;
        single.customerGuid = element.customerGuid;
        single.isFromArchive = element.isFromArchive;
        single.isCustomerWaiting = element.isCustomerWaiting;
        single.reasonForDeletion = element.reasonForDeletion;
        single.reasonForCancellation = element.reasonForCancellation;
        single.isDeleted = element.isDeleted;
        single.widgetAppointmentNo = element.widgetAppointmentNo;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  open(content, appointment) {
    this.isDisplayInvoice = false;
    this.InvoicePrice = '';
    this.GetAppointmentDetail(appointment.id);
    this.SelectedStatus = null;
    this.updateAppointmentStatusModel.customerName = appointment.customerName;
    this.updateAppointmentStatusModel.dealerName = appointment.dealerName;
    this.updateAppointmentStatusModel.licensePlate = appointment.licensePlate;
    this.updateAppointmentStatusModel.WOnumber = appointment.workOrderNo;
    this.updateAppointmentStatusModel.jobDetails = appointment.jobDetails;
    this.updateAppointmentStatusModel.WOstatusColor = appointment.workOrderStatusColor;
    this.updateAppointmentStatusModel.appointmentId = appointment.id;
    this.updateAppointmentStatusModel.appointmnetStatusColor = appointment.appointmentStatusColor;
    this.updateAppointmentStatusModel.bookDate = appointment.bookedDate;
    this.updateAppointmentStatusModel.WOstatusId = appointment.workOrderStatusId;
    this.updateAppointmentStatusModel.approvedDemand = appointment.approvedDemand;
    this.updateAppointmentStatusModel.WOstatus = appointment.workOrderStatus;
    this.updateAppointmentStatusModel.model = appointment.modelName;
    this.updateAppointmentStatusModel.appointmentStatusId = appointment.appointmentStatusId;
    this.updateAppointmentStatusModel.brandImg = appointment.brand;
    this.updateAppointmentStatusModel.appointmentGuid = appointment.appointmentGuid;
    this.updateAppointmentStatusModel.appointmentStatus = appointment.appointmentStatus;
    this.updateAppointmentStatusModel.bookDateTime = appointment.bookedDateTime;
    this.updateAppointmentStatusModel.appointmentType = appointment.appointmentType;
    this.updateAppointmentStatusModel.customerGuid = appointment.customerGuid;
    this.isCurrentAppointmentOnHold= (appointment.workOrderStatusId===Enums.WOStatus.OnHold) ? true : false;
    this.modalService.open(content, { size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  async GetAppointmentDetail(Id: number) {
    let language = this.cookieservice.get('userSelectedLanguage')
    await this.appointmentService.GetAppointmentDetail(Id, language).then(result => {
      if (result.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.contactDetails = result.responseObject;
        this.cdr.detectChanges();
      }
      else {
        this.spinner.hide();
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }

  onBlur(event) {
    this.InvoicePrice = event.target.value;

  }
  private ExcelDataMapping(appointmentList: any) {
    let supperArray = [];
    if (appointmentList && appointmentList.length > 0) {
      for (let index = 0; index < appointmentList.length; index++) {
        const element = appointmentList[index];
        let single = Object();
        single.SrNo = this.currentPageNumber(index);
        single.Type = element.appointmentType;
        single.LicensePlate = element.licensePlate;
        single.ModelName = element.modelName;
        single.BrandName = element.brandName;
        single.DealerName = element.dealerName;
        single.CustomerName = element.customerName;
        single.MobileNumber = element.mobileCode ? '+' + element.mobileCode + element.mobileNo : element.mobileNo;
        single.WoNo = element.workOrderNo;
        single.WoStatus = element.workOrderStatus;
        single.BookedDate = element.bookedDate;
        single.CreatedDate = element.createdDate;
        this.appointmentStatusList.forEach(ele => {
          if (ele.id === element.appointmentStatusId) {
            single.Status = ele.name;
          }
        })
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  /**
 * Methid to generate auto row number based on per page size
 * @param cIndex
 */
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }
    return rtPageNumber;
  }

  OpenSaveSearchModal(content) {
    this.saveSearchFilter.saveSearchArray = [];
    this.control = new FormControl();
    this.createSaveSearchModel();
    if (this.saveSearchFilter.saveSearchArray.length > 0) {
      this.modalService.open(content, { size: 'xl', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    else {
      let ErrorMsg = this.translate.instant("lblPleaseFillAtleastOneField");
      this.toastr.error(ErrorMsg);
    }
  }

  createSaveSearchModel() {
    this.saveSearchFilter.filterName = null;
    if (this.selectedItems.length > 0) {
      this.archivedAppointmentService.appointmentRequestModel.sourceOfCreation = this.selectedItems.map(x => x.value).join(',')
    }
    let searchModel: SearchArrayModel =
    {
      searchColumnName: "lblIsRentalCar",
      searchValue: (this.archivedAppointmentService.appointmentRequestModel.isRentalCar === 1) ? "True" : "False",
      searchActualValue: (this.archivedAppointmentService.appointmentRequestModel.isRentalCar === 1) ? "True" : "False",
    }
    this.saveSearchFilter.saveSearchArray.push(searchModel);
     searchModel =
    {
      searchColumnName: "lblCurrentOffer",
      searchValue: (this.archivedAppointmentService.appointmentRequestModel.currentOffer === 1) ? "True" : "False",
      searchActualValue: (this.archivedAppointmentService.appointmentRequestModel.currentOffer === 1) ? "True" : "False",
    }
    this.saveSearchFilter.saveSearchArray.push(searchModel);
     searchModel =
    {
      searchColumnName: "lblCustomerWaiting",
      searchValue: (this.archivedAppointmentService.appointmentRequestModel.customerWaiting === 1) ? "True" : "False",
      searchActualValue: (this.archivedAppointmentService.appointmentRequestModel.customerWaiting === 1) ? "True" : "False",
    }
    this.saveSearchFilter.saveSearchArray.push(searchModel);
    
    if(this.isNeedAttentionActive){
      searchModel =
      {
        searchColumnName: "lblNeedAttention",
        searchValue: (this.archivedAppointmentService.appointmentRequestModel.needAttention === 1) ? "True" : "False",
        searchActualValue: (this.archivedAppointmentService.appointmentRequestModel.needAttention === 1) ? "True" : "False",
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    
    if(this.isTireHotelActive){
      searchModel =
      {
        searchColumnName: "lblTireHotel",
        searchValue: (this.archivedAppointmentService.appointmentRequestModel.isTireHotel) ? "True" : "False",
        searchActualValue: (this.archivedAppointmentService.appointmentRequestModel.isTireHotel) ? "True" : "False",
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

     searchModel =
    {
      searchColumnName: "lblIncludeArchive",
      searchValue: (this.archivedAppointmentService.appointmentRequestModel.includeArchive === true) ? "True" : "False",
      searchActualValue: (this.archivedAppointmentService.appointmentRequestModel.includeArchive === true) ? "True" : "False",
    }
    this.saveSearchFilter.saveSearchArray.push(searchModel);
    if (this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblAppointmentStatus",
        searchValue: this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId.toString(),
        searchActualValue: this.globalSetting.getAppointmentStatusName(this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId)
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblWorkOrderStatus",
        searchValue: this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId.toString(),
        searchActualValue: this.globalSetting.getWorkOrderStatus(this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId)
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.archivedAppointmentService.appointmentRequestModel.licensePlate) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblLicensePlate",
        searchValue: this.archivedAppointmentService.appointmentRequestModel.licensePlate.toString(),
        searchActualValue: this.archivedAppointmentService.appointmentRequestModel.licensePlate
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.archivedAppointmentService.appointmentRequestModel.woNumber) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblWoNo",
        searchValue: this.archivedAppointmentService.appointmentRequestModel.woNumber.toString(),
        searchActualValue: this.archivedAppointmentService.appointmentRequestModel.woNumber
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.archivedAppointmentService.appointmentRequestModel.appointmentType) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblAppointmenttype",
        searchValue: this.archivedAppointmentService.appointmentRequestModel.appointmentType.toString(),
        searchActualValue: this.archivedAppointmentService.appointmentRequestModel.appointmentType
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.archivedAppointmentService.appointmentRequestModel.documentPartStatus) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblDocumentPartStatus",
        searchValue: this.archivedAppointmentService.appointmentRequestModel.documentPartStatus,
        searchActualValue: this.archivedAppointmentService.appointmentRequestModel.documentPartStatus
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.archivedAppointmentService.appointmentRequestModel.brandCode) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblBrand",
        searchValue: this.archivedAppointmentService.appointmentRequestModel.brandCode,
        searchActualValue: this.archivedAppointmentService.appointmentRequestModel.brandCode
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.archivedAppointmentService.appointmentRequestModel.customerName) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCustomer",
        searchValue: this.archivedAppointmentService.appointmentRequestModel.customerName.toString(),
        searchActualValue: this.archivedAppointmentService.appointmentRequestModel.customerName
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.archivedAppointmentService.appointmentRequestModel.mobileNumber) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblMobileNumber",
        searchValue: this.archivedAppointmentService.appointmentRequestModel.mobileNumber.toString(),
        searchActualValue: this.archivedAppointmentService.appointmentRequestModel.mobileNumber
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
      let bookingDateFormatted= this.getFormattedDate(this.bookingDate);
      searchModel =
      {
        searchColumnName: "lblBookedDateRange",
        searchValue: bookingDateFormatted,
        searchActualValue: bookingDateFormatted
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
      let createdDateFormatted= this.getFormattedDate(this.createdDate);
      searchModel=
      {
        searchColumnName: "lblCreatedDateRange",
        searchValue: createdDateFormatted,
        searchActualValue: createdDateFormatted
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    if (this.archivedAppointmentService.appointmentRequestModel.dealerId && this.isAdvanceDealerSearch) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSelectDealer",
        searchValue: this.archivedAppointmentService.appointmentRequestModel.dealerId.toString(),
        searchActualValue: this.dealerList.find(x => x.value === this.archivedAppointmentService.appointmentRequestModel.dealerId)?.text
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.serviceAdvisorSelected) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSelectServiceAdvisor",
        searchValue: this.serviceAdvisorSelected.toString(),
        searchActualValue: this.serviceAdvisorList.find(x => x.userId === this.serviceAdvisorSelected)?.userName
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.archivedAppointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblServiceAdvisorAuthorized",
        searchValue: "True",
        searchActualValue: "True"
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.mechanicSelected) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSelectMechanic",
        searchValue: this.mechanicSelected.toString(),
        searchActualValue: this.mechanics?.find(x => x.id === this.mechanicSelected)?.name
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.archivedAppointmentService.appointmentRequestModel.sourceOfCreation) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSource",
        searchValue: this.selectedItems.map(x => x.text).join(','),
        searchActualValue: this.selectedItems.map(x => x.text).join(',')
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
  }

  SaveAdvanceSearchFilter() {
    if (!this.saveSearchFilter.filterName.replace(/\s/g, "").length) {
      let errorMsg = this.translate.instant("lblSearchNameRequired");
      this.toastr.error(errorMsg);
      return;
    }
    this.advanceSearchService.SaveAdvanceSearchFilter(this.saveSearchFilter).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
        let successMsg = this.translate.instant("lblSearchFilteredSaved");
        this.toastr.success(successMsg);
        this.modalService.dismissAll();
      }
      else {
        let errorMsg = this.translate.instant("lblSaveSearchFilterNameAlreadyExists");
        this.toastr.error(errorMsg);
      }
    });
  }

  OpenSavedSearchListPopup() {
    this.spinner.show();
    this.GetAdvanceSearchList().then((_res) => {
      const modalRef = this.modalService.open(SavedSearchComponent, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
      });
      modalRef.componentInstance.isFromAppointment = true;
      modalRef.componentInstance.searchList = this.savedSearchListResponse;
      modalRef.componentInstance.onReset.subscribe((_data) => {
        this.onResetSaveSearch();
      });
      modalRef.componentInstance.onEditOrRun.subscribe((data) => {
        if (!data.isRun) {
          this.onReset();
        }
        this.ApplySaveSearch(data.searchData, data.isRun);
      });
      modalRef.componentInstance.onDelete.subscribe((data) => {
        this.OnDeleteSaveSearch(data, modalRef);
      });
    });
  }

  async GetAdvanceSearchList() {
    await this.advanceSearchService.GetAdvanceSearchList(Enums.ModuleNames.ArchivedAppointment).then(result => {
      if (result) {
        if (result.responseObject.errorCount) {
          this.spinner.hide();
        }
        else {
          this.savedSearchListResponse = result.responseObject;
          let dealerId: string;
          this.savedSearchListResponse.forEach(element => {
            element.saveSearchArray.forEach(async val => {
              if (val.searchColumnName === 'lblAppointmentStatus') {
                val.searchActualValue = this.globalSetting.getAppointmentStatusName(+val.searchValue);
              }
              else if (val.searchColumnName === 'lblWorkOrderStatus') {
                val.searchActualValue = this.globalSetting.getWorkOrderStatus(+val.searchValue);
              }
              else if (val.searchColumnName === 'lblSelectDealer') {
                dealerId = val.searchValue;
                val.searchActualValue = this.dealerList.find(x => x.value === val.searchValue)?.text;
              }
              else if (val.searchColumnName === 'lblSelectServiceAdvisor') {
                await this.appointmentCommonService.getServiceAdvisorDetails(dealerId);
                this.serviceAdvisorList = this.appointmentCommonService.serviceAdvisorList;
                const serviceAdvisor = this.serviceAdvisorList.find(x => x.userId.toString() === val.searchValue);
                val.searchActualValue = serviceAdvisor?.userName || val.searchValue;
              }
              else if (val.searchColumnName === 'lblSelectMechanic') {
                this.dealerId = dealerId;
                await this.getAllMechanics();
                const mechanic = this.mechanics.find(x => x.id.toString() === val.searchValue);
                val.searchActualValue = mechanic?.name || val.searchValue;
              }
              else if (val.searchColumnName === 'lblBrand') {
                val.searchActualValue = this.brandList?.find(x => x.brandCode === val.searchValue)?.brandName || val.searchValue;
              }
              else {
                val.searchActualValue = val.searchValue;
              }
            });
          });
        }
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }

  OnDeleteSaveSearch(searchName, outerModalRef) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblSavedFilters"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
       // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.deleteSearchFilter.filterName = searchName;
        this.advanceSearchService.DeleteAdvanceSearch(this.deleteSearchFilter).then(response => {
          if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
            this.GetAdvanceSearchList().then(() => outerModalRef.dismiss());
            let msg = this.translate.instant("lblSaveSearchDeletedSuccessfully");
            this.toastr.success(msg);
          }
          else {
            let msg = this.translate.instant("lblFailedTodeleteSaveSearch");
            this.toastr.error(msg);
          }
        }, error => {
          if (error.status === Constant.BadRequest) {
            let WarningMessage = this.translate.instant("lblErrorWarningForValue")
            this.toastr.warning(WarningMessage);
          }
          else {
            let errorMessage = this.translate.instant("lblErrorMessage");
            this.toastr.error(errorMessage);
          }

        });
      }
    });
  }
  DeleteAppointment(appointment: any) {
    
    try{  let modelHeadermsg = this.translate.instant("lblDelete");
          let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblAppointment"), true);
          const modalRef = this.modalService.open(NgbdModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = modelBodymsg;
          modalRef.result.then((_result) => { 
            // This is intentional
            }, (reason) => {
            this.popupCloseResult = this.getDismissReason(reason);
            if (this.popupCloseResult) {
              let deleteModel ={
                appointmentId : appointment.id,
                workOrderNo : appointment.workOrderNo,
                licensePlate : appointment.licensePlate,
                userId : "",
                isDeleteFromDms : false,
              }
              this.spinner.show();
              this.archivedAppointmentService.DeleteArchivedAppointment(deleteModel).then((response) => {           
                if (response.responseCode == Constant.SuccessResponseCode) {
                  let successMsg = this.translate.instant("lblAppointmentDeleted");
                  this.toastr.success(successMsg);
                  this.onRefresh();
                }
                else {
                  let errorMsg = this.translate.instant("lblAppointmentNotDeleted");
                  this.toastr.error(errorMsg);
                }
              });
            }
              });
      }
      finally{
        this.spinner.hide();
      }
  }
SearchValues(searchValue){
  if(searchValue === "True"){
    return 1;
  }else{
    if(searchValue === "False"){
      return 0;
    }else{
      return 2;
    }
  }
}
  async ApplySaveSearch(data, isRunSearch) {
    if (data) {
      let saveSearchDetail = this.savedSearchListResponse.filter(x => x.filterName === data);
      if (saveSearchDetail.length > 0 && saveSearchDetail[0]) {
        for (const element of saveSearchDetail[0].saveSearchArray) {
          switch (element.searchColumnName) {
            case 'lblIsRentalCar':
              this.archivedAppointmentService.appointmentRequestModel.isRentalCar = this.SearchValues(element.searchValue);
              this.isRentalCar = (element.searchValue === "True") ? true : false;
              break;
            case 'lblCurrentOffer':
              this.archivedAppointmentService.appointmentRequestModel.currentOffer = this.SearchValues(element.searchValue);
              this.currentOffer = (element.searchValue === "True") ? true : false;
              break;
            case 'lblCustomerWaiting':
                this.archivedAppointmentService.appointmentRequestModel.customerWaiting = (element.searchValue === "True" ? 1 :  0 );
                this.isCustomerWaiting = (element.searchValue === "True") ? true : false;
                break;
            case 'lblAppointmentStatus':
              this.archivedAppointmentService.appointmentRequestModel.appointmentStatusId = +element.searchValue;
              break;
            case 'lblWorkOrderStatus':
              this.archivedAppointmentService.appointmentRequestModel.workOrderStatusId = +element.searchValue;
              break;
            case 'lblLicensePlate':
              this.archivedAppointmentService.appointmentRequestModel.licensePlate = element.searchValue;
              break;
            case 'lblWoNo':
              this.archivedAppointmentService.appointmentRequestModel.woNumber = element.searchValue;
              break;
            case 'lblAppointmenttype':
              this.archivedAppointmentService.appointmentRequestModel.appointmentType = element.searchValue;
              break;
            case 'lblDocumentPartStatus':
              this.archivedAppointmentService.appointmentRequestModel.documentPartStatus = element.searchValue;
              break;
            case 'lblBrand':
              this.archivedAppointmentService.appointmentRequestModel.brandCode = element.searchValue;
              break;
            case 'lblNeedAttention':
              this.archivedAppointmentService.appointmentRequestModel.needAttention = (element.searchValue === "True") ? 1 : 0;
              this.needAttention = (element.searchValue === "True") ? 1 : 0;
              break;
            case 'lblCustomer':
              this.archivedAppointmentService.appointmentRequestModel.customerName = element.searchValue;
              break;
            case 'lblMobileNumber':
              this.archivedAppointmentService.appointmentRequestModel.mobileNumber = element.searchValue;
              break;
            case 'lblBookedDateRange':
              let dateValue = element.searchValue.split("-");
              if (dateValue.length > 1) {
                let startDateParts = dateValue[0].trim().split("/");
                let startDate = new Date(+startDateParts[2], +startDateParts[1] - 1, +startDateParts[0]);
                let endDateParts = dateValue[1].trim().split("/");
                let endDate = new Date(+endDateParts[2], +endDateParts[1] - 1, +endDateParts[0]);
                this.bookingDate = [];
                this.bookingDate.push(startDate);
                this.bookingDate.push(endDate);
              }
              break;
            case 'lblCreatedDateRange':
              let createdDateValue = element.searchValue.split("-");
              if(createdDateValue.length > 1){
                let createdStartDateParts = createdDateValue[0].trim().split("/");
                let createdStartDate = new Date(+createdStartDateParts[2], +createdStartDateParts[1] - 1, +createdStartDateParts[0]);
                let createdEndDateParts = createdDateValue[1].trim().split("/");
                let createdEndDate = new Date(+createdEndDateParts[2], +createdEndDateParts[1] - 1, +createdEndDateParts[0]);
                this.createdDate=[];
                this.createdDate.push(createdStartDate);
                this.createdDate.push(createdEndDate);
              }
              break;
            case 'lblSelectDealer':
              await this.onDealerSelected(element.searchValue, 'advanceSearchDealerDropdown');
              break;
            case 'lblSelectServiceAdvisor':
              await this.appointmentCommonService.getServiceAdvisorDetails(this.dealerId);
              this.serviceAdvisorList = this.appointmentCommonService.serviceAdvisorList;
              this.serviceAdvisorSelected = element.searchValue;
              this.archivedAppointmentService.appointmentRequestModel.serviceAdvisorId = element.searchValue;
              break;
            case 'lblServiceAdvisorAuthorized':
              this.archivedAppointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor = element.searchValue === "True";
              break;
            case 'lblSelectMechanic':
              if (!this.mechanics || this.mechanics.length === 0) {
                await this.getAllMechanics();
              }
              this.mechanicSelected = Number(element.searchValue) as any;
              this.archivedAppointmentService.appointmentRequestModel.mechanicId = element.searchValue;
              break;
            case 'lblSource':
              this.handleSource(element, this.applicationSourceList);
              break;
            default:
              break;
          }
        }
      }
      if (isRunSearch) {
        this.AdvanceSearchSubmit();
      }
      else {
        this.onSearch();
      }
    }
  }
  OpenEditView(appointment:any)
  {
    this.onView(appointment);
  }
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datepipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datepipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
